import { useState, useCallback } from "react";
import { sendInvitation } from "../api/invitations";

export function useSendInvitation() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const submit = useCallback(async (email: string) => {
    setError(null);
    setSuccess(false);
    setLoading(true);
    try {
      const result = await sendInvitation(email);
      if (result.ok) {
        setSuccess(true);
      } else {
        setError(result.error);
      }
      return result;
    } catch {
      setError("An unexpected error occurred.");
      return { ok: false as const, error: "An unexpected error occurred." };
    } finally {
      setLoading(false);
    }
  }, []);

  return { submit, loading, error, success };
}
